<template>
    <PlanbordFunctionCell>
        <div>
            <span v-for="name in resourceNames" :key="name" class="function-marker">
                {{ name }}
            </span>
        </div>
    </PlanbordFunctionCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {ResourceFunction} from '@cquential/api';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';

    @Component({
        components: {
            PlanbordFunctionCell,
        },
    })
    export default class ResourceFunctionsCell extends Vue {
        @Prop({required: true}) public resource!: ResourceWithKeyedByDateObjects;

        public get resourceNames(): string[] {
            if (!this.resource.functions) {
                return [];
            }

            return this.resource.functions.map((e: ResourceFunction): string => {
                return e.name;
            });
        }
    }
</script>

<style lang="scss" scoped>
    div {
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: left;

        .function-marker {
            border-radius: 10px;
            color: var(--function-marker-color);
            background: var(--function-marker-background);
            hyphens: auto;
            overflow-wrap: break-word;
            padding: 0.2rem 0.4rem;
            margin: 0.1rem;
        }
    }
</style>
